import(/* webpackMode: "eager" */ "/Users/dipnerreddy/Desktop/portfolio-main/app/page.tsx")